export default __webpack_public_path__ + "static/matheo-b8b6a6f6754896e3acbb978aed891de9.jpg";